import React, {useState} from "react";
import ReactPDF from "@react-pdf/renderer";
import { format, parse, parseISO } from "date-fns";
import MaestroRelationship from "./MaestroRelationship";
import { formatDate } from "@utils/dates";
import { formatCurrency } from "@utils/numbers";
import { getPreferredPhone } from "@api/contactService";
import { primaryProperty } from "@api/businessService";
import {
    Table as PDFTable,
    TableHeader,
    TableCell,
    TableBody,
    DataTableCell,
} from '@david.kucsai/react-pdf-table';
import { Button, IconButton, Table, Tooltip, Typography } from "@mui/joy";
import MaestroSelect from "./MaestroSelect";
import { useAuth } from "@providers/AuthProvider";
import SendToModal from "./SendToModal";
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import ObjectRelationshipTable from "@components/objects/ObjectRelationshipTable";

// import { useTable } from "react-table";
/*
import * as Virtualized from 'react-virtualized';
import 'react-virtualized/styles.css'; // only needs to be imported once
*/

const genericBusinessColumns = [
    {
        title: 'Business',
        pdfCell: (row) => row.name,
        cell: (row) => {
            return <MaestroRelationship type="business" id={row.id} community={row.community.subdomain}>{row.name}</MaestroRelationship>
        }
    }
];
const dateBusinessColumns = (dateField) => [
    {
        title: 'Business',
        pdfCell: (row) => row.name,
        cell: (row) => {
            return <MaestroRelationship type="business" id={row.id} community={row.community.subdomain}>{row.name}</MaestroRelationship>
        }
    },
    {
        title: 'Date',
        cell: (row) => {
            return formatDate(row[dateField])
        }
    },
]
const datePropertyColumns = (dateField) => [
    {
        title: 'Property',
        pdfCell: (row) => row.address,
        cell: (row) => {
            return <MaestroRelationship type="property" id={row.id} community={row.community.subdomain}>{row.address}</MaestroRelationship>
        }
    },
    {
        title: 'Date',
        cell: (row) => {
            return formatDate(row[dateField])
        }
    },
]

const objectFields = {
    contacts: {
        columns: [
            {
                title: 'Name',
                cell: (row) => {
                    return <MaestroRelationship type={'contact'} id={row.id} community={row.community.subdomain}>{row.name}</MaestroRelationship>
                },
            },
            {
                title: 'Email',
                cell: (row) => {
                    return <>
                        {/*
                        {row.email && (
                            <Button
                                component="a"
                                href={`mailto:${row.email}`}
                                size='sm'
                                variant='outlined'
                                sx={{mr: 1}}
                                startDecorator={<EmailRoundedIcon/>}
                            >
                                Email
                            </Button>
                        )}
                        */}
                        {row.email && (
                        <Typography
                            component="a"
                            href={`mailto:${row.email}`}
                            target="_blank"
                            startDecorator={<EmailRoundedIcon/>}
                        >{row.email}</Typography>
                        )}
                        {/* <span>{row.email}</span> */}
                    </>
                },
            },
            {
                title: 'Phone',
                cell: (row) => {
                    return getPreferredPhone(row);
                },
            },
        ],
    },
    businesses: {
        columns: [
            {
                title: 'Name',
                cell: (row) => {
                    return <MaestroRelationship type={'business'} id={row.id} community={row.community.subdomain}>{row.name}</MaestroRelationship>
                },
            },
            {
                title: 'Address',
                cell: (row) => {
                    return row.business_locations ? primaryProperty(row.business_locations)?.address ?? '' : '';
                },
            },
            // hours
        ],
    },
    properties: {
        columns: [
            {
                title: 'Address',
                cell: (row) => {
                    return <MaestroRelationship type={'property'} id={row.id} community={row.community.subdomain}>{row.address}</MaestroRelationship>
                },
            },
            {
                title: 'Units',
                cell: (row) => {
                    if(!row.hasOwnProperty('property_units') || row.property_units.length === 0) {
                        return (<span>N/A</span>);
                    }

                    let commericalUnits = [];
                    let residentialUnits = [];

                    row.property_units.map((unit, index) => {
                        if(unit.residential) {
                            residentialUnits.push(unit);
                        } else {
                            commericalUnits.push(unit);
                        }
                    });

                    return (<>
                    {!(row.business_unit_names || row.residential_unit_names) && (<>


                        {commericalUnits.length > 0 && (<div>
                            <b>Commercial:</b> {commericalUnits.map((unit, index) => (<React.Fragment key={index}>
                                <Tooltip title={unit.residential ? ('Residential (' + (unit.occupied ? 'Occupied' : 'Vacant')+')') : 'Commercial'}>
                                    <Typography sx={{display: 'inline'}}>{unit.unit}</Typography>
                                </Tooltip>
                                {index+1 < commericalUnits.length ? ', ' : ''}
                            </React.Fragment>))}
                        </div>)}
                        {residentialUnits.length > 0 && (<div>
                            <b>Residential:</b> {residentialUnits.map((unit, index) => (<React.Fragment key={index}>
                                <Tooltip title={unit.residential ? ('Residential (' + (unit.occupied ? 'Occupied' : 'Vacant')+')') : 'Commercial'}>
                                    <Typography sx={{display: 'inline'}}>{unit.unit}</Typography>
                                </Tooltip>
                                {index+1 < residentialUnits.length ? ', ' : ''}
                            </React.Fragment>))}
                        </div>)}

                        {/*
                        {row.property_units.map((unit, index) => (<React.Fragment key={index}>
                            <Tooltip title={unit.residential ? ('Residential (' + (unit.occupied ? 'Occupied' : 'Vacant')+')') : 'Commercial'}>
                                <Typography>{unit.unit}</Typography>
                            </Tooltip>
                            {index+1 < row.property_units.length ? ', ' : ''}
                        </React.Fragment>))}
                        */}
                    </>)}
                    {row.business_unit_names && (
                        <div>
                            <b>Commercial:</b> {row.business_unit_names}
                        </div>
                    )}
                    {row.residential_unit_names && (
                        <div>
                            <b>Residential:</b> {row.residential_unit_names}
                        </div>
                    )}
                </>)}
            },
            {
                title: 'Owner',
                cell: (row) => {
                    return (<>
                            {/* <ObjectPreview to={`/contacts/${row.owner_id}`} object={object?.owner} community={row.community.subdomain}>{object?.owner?.name ?? 'N/A'}</ObjectPreview> */}
                        {row.owner && row.owner_type == 'App\\Models\\Contact' && (
                            <MaestroRelationship type='contact' id={row.owner.id} object={row.owner}>{row.owner.name}</MaestroRelationship>
                        )}
                        {row.owner && row.owner_type == 'App\\Models\\Business' && (
                            <MaestroRelationship type='business' id={row.owner.id} object={row.owner} community={row.community.subdomain}>{row.owner.name}</MaestroRelationship>
                        )}
                        {!row.owner && (
                            <span>N/A</span>
                        )}
                    </>);
                }
            }
        ]
    },
    'work-plans': {
        columns: [
            {
                title: 'Name',
                cell: (row) => {
                    return <>
                        <MaestroRelationship type={'workplan'} id={row.id} community={row.community.subdomain}>{row.name}</MaestroRelationship>
                        {row.contacts && row.contacts.length > 0 && (
                            <MaestroRelationship type={'contact'} id={row.contacts[0].id} community={row.community.subdomain}>{row.contacts[0].name}</MaestroRelationship>
                        )}
                    </>

                },
            },
            {
                title: 'Date',
                cell: (row) => {
                    return formatDate(row.workplan_date)
                },
            },
        ],
    },
    'workplan-tasks': {
        columns: [
            {
                title: 'Task Name',
                cell: (row) => {
                    return row.task_name

                },
            },
            {
                title: 'Work Plan',
                cell: (row) => {
                    return <>
                        <MaestroRelationship type={'workplan'} id={row.workplan_id} community={row.community.subdomain}>{row.workplan.name}</MaestroRelationship>
                    </>

                },
            },
            //
            {
                title: 'Due Date',
                cell: (row) => {
                    // TODO: FIGURE OUT HOW TO INCLUDE PAST-DUE CLASSES
                    return formatDate(row.due_date)
                },
            },
        ]
    },
    'volunteer-hours': {
        columns: [
            {
                title: 'Name',
                cell: (row) => {
                    return row.contact ? <MaestroRelationship type={'contact'} id={row.contact.id} community={row.community.subdomain}>{row.contact.name}</MaestroRelationship> : 'N/A'
                },
            },
            {
                title: 'Entry',
                cell: (row) => {
                    return !row.task_info ? '' : <>
                        <span className="title">
                            {row.task_info.task_name && (
                                <MaestroRelationship type="workplan" id={row.task_info.workplan_id} community={row.community.subdomain}><i className="icon-list3"></i> {row.task_info.task_name}</MaestroRelationship>
                            )}
                            {row.opportunity && (
                                <MaestroRelationship type="opportunity" id={row.opportunity.id} community={row.community.subdomain}><i className="icon-group-work"></i> {row.opportunity.name}</MaestroRelationship>
                            )}
                            {!row.task_info && !row.opportunity && <span>Quick Add</span>}
                        </span>
                    </>

                },
            },
            {
                title: 'Involvement',
                cell: (row) => {
                    return row.involvement?.name ?? '';
                },
            },
            {
                title: 'Notes',
                cell: (row) => {
                    return <span className="text-ellipsis show-medium">{row.notes}</span>;
                },
            },
            {
                title: 'Hours',
                cell: (row) => {
                    return <span className="text-ellipsis show-medium">{row.time_taken}</span>;
                },
            },
        ]
    },
    donations: {
        columns: [
            {
                title: 'Donor',
                cell: (row) => {
                    /*
                    <span ng-if="row.anonymous">Anonymous</span>
                    <span ng-if="row.anonymous && globalScope.current_user.user_permissions['donation']['view-full']">({{ row.donor.name }})</span>
                    <span ng-if="!row.anonymous">{{ row.donor.name }}</span>
                    */
                    return <MaestroRelationship type={'donation'} id={row.donation_id} community={row.community.subdomain}>{row.donation?.donor?.name ?? 'N/A'}</MaestroRelationship>
                },
            },
            {
                title: 'Amount',
                cell: (row) => {
                    return formatCurrency(row.amount);
                },
            },
            {
                title: 'Date',
                cell: (row) => {
                    return row.received ? formatDate(row.received) : '(Not Received)'
                },
            },
        ]
    },
    opportunities: {
        columns: [
            {
                title: 'Name',
                cell: (row) => {
                    return <MaestroRelationship type={'opportunity'} id={row.id} community={row.community.subdomain}>{row.name}</MaestroRelationship>
                },
            },
            {
                title: 'Attached',
                cell: (row) => {
                    return <>
                        {row.workplan && (<div><b>Work Plan:</b> <MaestroRelationship type={'workplan'} id={row.workplan_id} community={row.community.subdomain}>{row.workplan.name}</MaestroRelationship></div>)}
                        {row.event && (<div><b>Event:</b> <MaestroRelationship type={'event'} id={row.event_id} community={row.community.subdomain}>{row.event.name}</MaestroRelationship></div>)}
                        {!row.workplan && !row.event && 'N/A'}
                    </>
                },
            },
            {
                title: 'Slots',
                cell: (row) => {
                    let jobSum = 0;
                    for(const job of row.jobs) {
                        jobSum += (job.quantity * job.available_time_slots.length);
                    }

                    if(jobSum === 0) {
                        return 'N/A';
                    }

                    return `${row.sign_ups.length} / ${jobSum}`;
                },
            },
            {
                title: 'Hours Attached?',
                cell: (row) => {
                    return row.volunteer_hours.length ? 'Yes' : 'No';
                },
            },
        ]
    },


    businesses_relocated_in: {
        columns: [...genericBusinessColumns],
    },
    businesses_relocated_out: {
        columns: [...genericBusinessColumns],
    },
    not_for_profit: {
        iterable_column: 'businesses',
        columns: [...genericBusinessColumns],
    },
    new_businesses: {
        iterable_column: 'businesses',
        columns: dateBusinessColumns('open_date'),
    },
    closed_businesses: {
        iterable_column: 'businesses',
        columns: dateBusinessColumns('close_date'),
    },

    improved_properties: {
        iterable_column: 'improvements',
        columns: [
            {
                title: 'Property',
                pdfCell: (row, rootItem) => {
                    if(!rootItem.hasOwnProperty('properties')) return 'N/A';
                    const property = rootItem.properties.hasOwnProperty(row.property_id) ? rootItem.properties[row.property_id] : null;//.filter(item => item.id === );
                    const address = property ? property.address : 'N/A';
                    return address
                },
                cell: (row, rootItem) => {
                    const property = rootItem.properties.hasOwnProperty(row.property_id) ? rootItem.properties[row.property_id] : null;//.filter(item => item.id === );
                    const address = property ? property.address : 'N/A';
                    return <MaestroRelationship type="property" id={row.property_id} community={row.community.subdomain}>{address}</MaestroRelationship>
                }
            },
            {
                title: 'Improvement',
                cell: (row) => {
                    return row.description
                }
            },
            {
                title: 'Amount',
                cell: (row) => {
                    return formatCurrency(row.amount)
                }
            },
        ],
    },

    sold_properties: {
        iterable_column: 'sales',
        columns: [
            {
                title: 'Property',
                pdfCell: (row, rootItem) => {
                    if(!rootItem.hasOwnProperty('properties')) return 'N/A';
                    const property = rootItem.properties.hasOwnProperty(row.property_id) ? rootItem.properties[row.property_id] : null;//.filter(item => item.id === );
                    const address = property ? property.address : 'N/A';
                    return address
                },
                cell: (row, rootItem) => {
                    const property = rootItem.properties.hasOwnProperty(row.property_id) ? rootItem.properties[row.property_id] : null;//.filter(item => item.id === );
                    const address = property ? property.address : 'N/A';
                    return <MaestroRelationship type="property" id={row.property_id} community={row.community.subdomain}>{address}</MaestroRelationship>
                }
            },
            {
                title: 'Date',
                cell: (row) => {
                    return formatDate(row.date)
                }
            },
            {
                title: 'Amount',
                cell: (row) => {
                    return formatCurrency(row.amount)
                }
            },
            {
                title: 'Former Owner',
                pdfCell: (row) => {
                    return row.former_owner ? row.former_owner.name : 'N/A';
                },
                cell: (row) => {
                    if(!row.former_owner) {
                        return 'N/A';
                    }

                    const ownerType = row.former_owner_type === 'App\\Models\\Business' ? 'business' : 'contact';

                    return <MaestroRelationship type={ownerType} id={row.former_owner_id} community={row.community.subdomain}>{row.former_owner.name}</MaestroRelationship>
                }
            },
        ],
    },
    new_properties: {
        iterable_column: 'properties',
        columns: datePropertyColumns('built_date'),
    },
    lost_properties: {
        iterable_column: 'properties',
        columns: [
            ...datePropertyColumns('lost_date'),
            {
                title: 'Reason',
                cell: (row) => {
                    return row.lost_reason
                }
            }
        ],
    },

    new_residential_units: {
        iterable_column: 'units',
        columns: [
            {
                title: 'Property',
                pdfCell: (row, rootItem) => {
                    if(!rootItem.hasOwnProperty('properties')) return 'N/A';
                    const property = rootItem.properties.hasOwnProperty(row.property_id) ? rootItem.properties[row.property_id] : null;//.filter(item => item.id === );
                    const address = property ? property.address : 'N/A';
                    return address
                },
                cell: (row, rootItem) => {
                    const property = rootItem.properties.hasOwnProperty(row.property_id) ? rootItem.properties[row.property_id] : null;//.filter(item => item.id === );
                    const address = property ? property.address : 'N/A';
                    return <MaestroRelationship type="property" id={row.property_id} community={row.community.subdomain}>{address}</MaestroRelationship>
                }
            },
            {
                title: 'Unit',
                cell: (row) => {
                    return row.unit
                }
            },
            {
                title: 'Rent',
                cell: (row) => {
                    return formatCurrency(row.rent)
                }
            },
        ],
    },
    total_residential_units_properties: {
        iterable_column: 'properties_without_units',
        columns: [
            {
                title: 'Property',
                pdfCell: (row, rootItem) => {
                    return row.address;
                },
                cell: (row, rootItem) => {
                    return <MaestroRelationship type="property" id={row.id} community={row.community.subdomain}>{row.address}</MaestroRelationship>
                }
            },
            {
                title: '# of Units',
                cell: (row) => {
                    return row.residential_units.toString();
                }
            },
        ],
    },
    total_residential_units_units: {
        iterable_column: 'units',
        columns: [
            {
                title: 'Property',
                pdfCell: (row, rootItem) => {
                    if(!rootItem.hasOwnProperty('properties_with_units')) return 'N/A';
                    const property = rootItem.properties_with_units.hasOwnProperty(row.property_id) ? rootItem.properties_with_units[row.property_id] : null;//.filter(item => item.id === );
                    const address = property ? property.address : 'N/A';
                    return address
                },
                cell: (row, rootItem) => {
                    const property = rootItem.properties_with_units.hasOwnProperty(row.property_id) ? rootItem.properties_with_units[row.property_id] : null;//.filter(item => item.id === );
                    const address = property ? property.address : 'N/A';
                    return <MaestroRelationship type="property" id={row.property_id} community={row.community.subdomain}>{address}</MaestroRelationship>
                }
            },
            {
                title: 'Unit',
                cell: (row) => {
                    return row.unit ?? 'N/A'
                }
            },
            {
                title: 'Rent',
                cell: (row) => {
                    return formatCurrency(row.rent)
                }
            },
        ],
    },
    total_commercial_units_properties: {
        iterable_column: 'properties_without_units',
        columns: [
            {
                title: 'Property',
                pdfCell: (row, rootItem) => {
                    return row.address;
                },
                cell: (row, rootItem) => {
                    return <MaestroRelationship type="property" id={row.id} community={row.community.subdomain}>{row.address}</MaestroRelationship>
                }
            },
            {
                title: '# of Units',
                cell: (row) => {
                    return row.commercial_units ? row.commercial_units.toString() : 1;
                }
            },
        ],
    },
    total_commercial_units_units: {
        iterable_column: 'units',
        columns: [
            {
                title: 'Property',
                pdfCell: (row, rootItem) => {
                    if(!rootItem.hasOwnProperty('properties_with_units')) return 'N/A';
                    const property = rootItem.properties_with_units.hasOwnProperty(row.property_id) ? rootItem.properties_with_units[row.property_id] : null;//.filter(item => item.id === );
                    const address = property ? property.address : 'N/A';
                    return address
                },
                cell: (row, rootItem) => {
                    const property = rootItem.properties_with_units.hasOwnProperty(row.property_id) ? rootItem.properties_with_units[row.property_id] : null;//.filter(item => item.id === );
                    const address = property ? property.address : 'N/A';
                    return <MaestroRelationship type="property" id={row.property_id} community={row.community.subdomain}>{address}</MaestroRelationship>
                }
            },
            {
                title: 'Unit',
                cell: (row) => {
                    return row.unit ?? 'N/A'
                }
            },
            {
                title: 'Rent',
                cell: (row) => {
                    return formatCurrency(row.rent)
                }
            },
        ],
    },

    public_improvements: {
        iterable_column: 'improvements',
        columns: [
            {
                title: 'Improvement',
                cell: (row) => {
                    return row.name
                }
            },
            {
                title: 'Date Completed',
                cell: (row) => {
                    return formatDate(row.completed_date)
                }
            },
            {
                title: 'Cost',
                cell: (row) => {
                    return formatCurrency(row.cost)
                }
            },
        ],
    },

    public_investments: {
        iterable_column: 'investments',
        columns: [
            {
                title: 'Name',
                cell: (row) => {
                    return row.name
                }
            },
            {
                title: 'Date Received',
                cell: (row) => {
                    return formatDate(row.received_date)
                }
            },
            {
                title: 'Amount',
                cell: (row) => {
                    return formatCurrency(row.amount)
                }
            },
        ],
    },

    events_held: {
        iterable_column: 'events',
        columns: [
            {
                title: 'Event',
                cell: (row) => {
                    return row.name
                }
            },
            {
                title: 'Dates',
                pdfCell: (row) => {
                    return row.dates.map((date, dateIndex) => (
                        <Text key={dateIndex} pdf={true}>{`${formatDate(date.start_date)} – ${formatDate(date.end_date)}`}</Text>
                    ))
                },
                cell: (row) => {
                    return row.dates.map((date, dateIndex) => (
                        <p key={dateIndex}>{`${formatDate(date.start_date)} – ${formatDate(date.end_date)}`}</p>
                    ))
                }
            },
        ],
    },

    grants_received: {
        iterable_column: 'grants',
        columns: [
            {
                title: 'Grant',
                cell: (row) => {
                    return row.name
                }
            },
            {
                title: 'Date Received',
                cell: (row) => {
                    return formatDate(row.awarded_date)
                }
            },
            {
                title: 'Amount',
                cell: (row) => {
                    return formatCurrency(row.value)
                }
            },
        ],
    },


    trainings_held: {
        iterable_column: 'trainings',
        columns: [
            {
                title: 'Training',
                cell: (row) => {
                    return row.name
                }
            },
            {
                title: 'Date',
                cell: (row) => {
                    return formatDate(row.training_date)
                }
            },
            {
                title: 'Attendees',
                cell: (row) => {
                    if(!row.contacts || !row.contacts.length) {
                        return 'N/A';
                    }

                    let people = [];
                    row.contacts.forEach(contact => {
                        people.push(contact.name);
                    })
                    return people.join(', ');
                    // return formatDate(row.training_date)
                }
            },
        ],
    },

    grouped_statistic: {
        columns: [
            {
                title: 'Community',
                cell: (row) => {
                    return row.name
                },
            },
            {
                title: 'Total',
                cell: (row) => {
                    return row.total
                },
            },
        ]
    }
};

const View = ({pdf = false, pdfStyles = {}, children}) => {
    if(pdf) {
        return <ReactPDF.View style={pdfStyles}>{children}</ReactPDF.View>
    }

    return <div>{children}</div>
};

const Text = ({pdf = false, children, bold = false}) => {
    if(pdf) {
        if(bold) {
            return <ReactPDF.Text style={{fontWeight: 'bold'}}>{children}</ReactPDF.Text>
        }
        return <ReactPDF.Text>{children}</ReactPDF.Text>
    }

    if(bold) {
        <span><b className="font-bold">{children}</b></span>
    }
    return <span>{children}</span>
};

const Sup = ({pdf = false, children}) => {
    if(pdf) {
        return <ReactPDF.Text style={{color: '#333', fontSize: 8}}>{children}</ReactPDF.Text>
    }

    return <sup>{children}</sup>
};

const Br = ({pdf = false, children}) => {
    if(pdf) {
        return <ReactPDF.View/>
    }

    return <br/>
};

const ReportObject = ({aggregate, item, communityCount = 1, pdf = false, pdfStyles = {}}) => {
    let auth = useAuth();

    const [isOpen, setIsOpen] = useState(false);
    let type = aggregate.value;
    let title = aggregate.label;// toCapitalizedWords(type);
    /*
    if(type === 'workplan-tasks') title = 'Tasks';
    if(type === 'workplans') title = 'Assigned Work Plans';
    if(type === 'involvements') title = 'Involvement';
    */

    let panelClass = 'default';
    if(type.match('contact'))
    {
        panelClass = 'contact';
    }
    else if(type.match('work'))
    {
        panelClass = 'work-plan';
    }
    else if(type.match('business') || type === 'not_for_profit')
    {
        panelClass = 'business';
    }
    else if(type.match('propert') && !type.match('improve'))
    {
        panelClass = 'property';
    }
    else if(type.match('event'))
    {
        panelClass = 'event';
    }
    else if(type.match('volunteer'))
    {
        panelClass = 'volunteer';
    }

    let iterable = [];
    if(objectFields.hasOwnProperty(type)) {
        if(typeof item.map === 'function') {
            iterable = item;
        }
        else if(objectFields[type].hasOwnProperty('iterable_column')) {
            iterable = item[objectFields[type].iterable_column];
            if(typeof iterable === 'object' && !Array.isArray(iterable)) {
                iterable = Object.values(iterable);
            }
        }
    }

    iterable = React.useMemo(() => iterable);

    const getObjectLength = () => iterable.length;

    let columnsForDisplay = [...objectFields[type].columns];

    //
    if(communityCount > 1) {
        columnsForDisplay.push({
            title: 'Community',
            cell: (row) => {
                return row.community.name
            }
        });
    }

    // this converts the columns to take our new table format
    // todo: convert column structure to new table format
    const transformedColumns = columnsForDisplay.map((column) => {
        column.label = column.title;
        column.render = {
            show: column.cell,
        }
        return column;
    });

    if(pdf) {
        if(getObjectLength() === 0) {
            return (
                <View pdf={true}><Text pdf={true}>N/A</Text></View>
            );
        }

        // return (<Text pdf={true}>PDF RENDER</Text>)
        return (<View pdf={true}>
            <PDFTable data={iterable}>
                <TableHeader
                    includeTopBorder={false}
                    includeRightBorder={false}
                    includeBottomBorder={false}
                    includeLeftBorder={false}
                >
                    {columnsForDisplay.map((v,k) => {
                        return (
                            <TableCell key={k} style={[pdfStyles.tableHeader, pdfStyles.tableCellHeader]}>{v.title}</TableCell>
                        );
                    })}

                </TableHeader>
                <TableBody
                    includeTopBorder={false}
                    includeRightBorder={false}
                    includeBottomBorder={false}
                    includeLeftBorder={false}
                    evenRowColor="#E1E1E1"
                    oddRowColor="white"
                >
                    {/* <DataTableCell getContent={(r) => 'Test'}/> */}

                    {columnsForDisplay.map((v,k) => {
                            {/* <DataTableCell key={k} getContent={(r) => v.cell(r)}/> */}
                        return (
                            <DataTableCell
                                key={k}
                                style={pdfStyles.tableCell}
                                getContent={(r) => v.hasOwnProperty('pdfCell') ? v.pdfCell(r, item) : v.cell(r, item)}
                            />
                        );
                    })}
                </TableBody>
            </PDFTable>
        </View>)
    }

    const IterableRow = React.memo(({dataIndex, objectFields, type, dataValue, item}) => (
        <tr>
            {columnsForDisplay.map((v,k) => {
                return (
                    <td key={k}>{v.cell(dataValue, item)}</td>
                );
            })}
        </tr>
    ));

    let Action = null;
    if(
        (type === 'contacts' || type === 'businesses')
        && getObjectLength() > 0
        && communityCount == 1
        && window.location.hostname.indexOf('conductor') === -1
        && auth.can('edit settings')
    ) {
        Action = (<>
            <Tooltip title={'Send To...'}>
                <IconButton
                    color="neutral"
                    variant="outlined"
                    size="sm"
                    sx={{
                        '--IconButton-size': '1.5rem',
                        bgcolor: 'background.surface',
                        verticalAlign: 'sub',
                        // ml: 0.5,
                        'svg': {
                            width: '1.05rem',
                            height: '1.05rem',
                        }
                    }}
                    onClick={()=>setIsOpen(true)}
                >
                    <FileUploadRoundedIcon/>
                </IconButton>
            </Tooltip>
            <SendToModal isOpen={isOpen} onClose={()=>setIsOpen(false)} type={type} objects={iterable} />
        </>)
    }

    return (
        <ObjectRelationshipTable
            tint={panelClass}
            title={title}
            columns={transformedColumns}
            relationship={iterable}
            data={item}
            collapsible={false}
            action={Action}
        />
    )
}

export default ReportObject;
export {
    View,
    Text,
    Sup,
    Br,
    objectFields,
};
